import { LoadingIcon } from "../icon/icons";
import { progressSpinner } from "./ProgressSpinner.css";

export function ProgressSpinner() {
  return (
    <div className={progressSpinner} role="progressbar">
      <LoadingIcon />
    </div>
  );
}
